import React, { useState } from 'react';
import Img from 'gatsby-image';
import { shape, string } from 'prop-types';

const Hero = ({ headline, subheadline, imageLandscape, imagePortrait, className }) => {
  const [isImgLoaded, setIsImgLoaded] = useState(false);

  return (
    <div className={`flex flex-col relative font-serifdisplay  ${className}`}>
      <Img
        onLoad={() => setIsImgLoaded(true)}
        className="hidden xl:block w-full h-90vh"
        loading="eager"
        fluid={imageLandscape.fluid}
        alt={imageLandscape.alt}
      />
      <Img
        onLoad={() => setIsImgLoaded(true)}
        className="xl:hidden w-full h-screen"
        loading="eager"
        fluid={imagePortrait.fluid}
        alt={imagePortrait.alt}
      />

      <div className="absolute top-0 w-full flex justify-end xl:h-full">
        <div
          style={{ backgroundColor: 'rgba(247, 228, 212, 0.9)' }}
          className="px-4 py-8 flex flex-col justify-center rounded-xl text-black md:py-24 xl:p-16 xl:rounded-none w-full xl:h-full xl:w-1/2"
        >
          <h1
            className={`text-3xl text-center mb-6 capitalize leading-none transform duration-1000 delay-300 lg:text-5xl xl:text-center xl:mb-8 ${
              isImgLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'
            }`}
          >
            {headline}
          </h1>
          <h2
            className={`text-xl text-center xl:text-center mb-0 transform duration-1000 delay-1000 ${
              isImgLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-full'
            }`}
          >
            {subheadline}
          </h2>
        </div>
      </div>
    </div>
  );
};

Hero.propTypes = {
  headline: string,
  subheadline: string,
  imageLandscape: shape({}),
  imagePortrait: shape({}),
  className: string,
};

Hero.defaultProps = {
  headline: null,
  subheadline: null,
  imageLandscape: null,
  imagePortrait: null,
  className: null,
};

export default Hero;
